import {BackendFactory} from 'dnd-core';
import React, {FC} from 'react';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';

import {FrontWindow, globalWindow} from '../../../libs/shared/helpers/src/browser/browserHelpers';

/*
 * Props.
 */

interface DragAndDropProviderProps {
  window?: FrontWindow;
  backend?: BackendFactory;
}

/*
 * Component.
 */

/** Simple wrapper around react-dnd's DragDropContext. */
export const DragAndDropProvider: FC<DragAndDropProviderProps> = (props) => {
  const {window, backend} = props;

  return (
    <DndProvider backend={backend || HTML5Backend} context={window || globalWindow}>
      {props.children}
    </DndProvider>
  );
};
